// Simple parse-a-chat: extracts phone (+91 formats), dates, event type, guest count.
export function parseChat(text) {
  const out = { name: '', phone: '', event_date: '', event_type: '', notes: text, guest_count: null };
  if (!text) return out;
  // Phone: +91 XXXXX XXXXX, +91XXXXXXXXXX, 10-digit
  const phoneMatch = text.match(/(\+91[\s-]?\d{5}[\s-]?\d{5}|\+91\d{10}|\b[6-9]\d{9}\b)/);
  if (phoneMatch) out.phone = phoneMatch[0].replace(/\s+/g, '');
  // Event type
  const events = ['mehendi','haldi','sangeet','roka','wedding','reception','engagement','party','shoot','trial'];
  const lower = text.toLowerCase();
  for (const ev of events) { if (lower.includes(ev)) { out.event_type = ev === 'wedding' || ev === 'reception' || ev === 'engagement' || ev === 'sangeet' || ev === 'mehendi' || ev === 'haldi' || ev === 'roka' ? 'bridal' : ev === 'party' ? 'party' : ev === 'shoot' ? 'photoshoot' : 'bridal'; break; } }
  // Date: 14 Feb, 14/02/2027, 14th February 2027
  const monthNames = { jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6, jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12 };
  const now = new Date();
  const yr = now.getFullYear();
  const named = text.match(/(\d{1,2})(?:st|nd|rd|th)?\s+(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?\s*(\d{4})?/i);
  if (named) {
    const d = parseInt(named[1]);
    const m = monthNames[named[2].toLowerCase().slice(0,3)];
    const y = named[3] ? parseInt(named[3]) : (m < now.getMonth() + 1 ? yr + 1 : yr);
    if (d && m) out.event_date = `${y}-${String(m).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
  }
  if (!out.event_date) {
    const slash = text.match(/(\d{1,2})[/-](\d{1,2})(?:[/-](\d{2,4}))?/);
    if (slash) {
      const d = parseInt(slash[1]), m = parseInt(slash[2]);
      let y = slash[3] ? parseInt(slash[3]) : yr;
      if (y < 100) y += 2000;
      if (d && m) out.event_date = `${y}-${String(m).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
    }
  }
  // Guest count: "for 5 people", "5 guests", "family of 4"
  const guest = text.match(/(\d+)\s*(?:people|guest|family|person|pax)/i);
  if (guest) out.guest_count = parseInt(guest[1]);
  // Name: first line before phone often has a name
  const firstLine = text.split(/\n|\.|,/)[0].trim();
  if (firstLine.length > 0 && firstLine.length < 50 && !/^\d/.test(firstLine)) {
    out.name = firstLine.replace(/^(hi|hello|hey|namaste|dear)[,\s]+/i, '').replace(/^this is /i, '').split(/\s+/).slice(0, 3).join(' ');
  }
  return out;
}
